import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Edit from '../../../../icons/edit.svg'
import Avatar from '../../../../icons/iconAvatar.svg'
import { setConfirmationModal } from '../../../../redux/actions/confirmationModal'
import EditUserDetails from '../../../NestedComponents/Option 2/SettingsModals/EditUserDetails'

const UserDetailsChange = () => {
  const { userDetails } = useSelector((state) => state)
  const dispatch = useDispatch()
  const handleEditClick = () => {
    dispatch(
      setConfirmationModal({
        headerText: 'Vollständigen Namen bearbeiten',
        body: <EditUserDetails />,
        large: true,
        headerBorder: true,
        modalFromSettings: true,
      }),
    )
  }
  return (
    <div>
      <div>
        <img src={Avatar} alt={Avatar} />
      </div>
      <div>
        <p>Vollständiger Name</p>
        <p>
          {userDetails.firstName}&nbsp;{userDetails.lastName}
        </p>
      </div>
      <div onClick={handleEditClick}>
        <img src={Edit} alt={Edit} />
      </div>
    </div>
  )
}

export default UserDetailsChange

// <p>Name ändern</p>
